import InputHandler from "./InputHandler";
import { MdDelete } from "react-icons/md";
import React from "react";
import { ButtonActionStyled, EduCardStyled } from "../../../styled/Resume";
import { FaPlus } from "react-icons/fa6";
import { useTheme } from "../../UI/Theme/ThemeContext";

const EducationCard = (props) => {
  const { eduArray, handleEduExpChange, handleDeleteEduInfo, handleAddEduInfo } =
    props;

  const { themeName } = useTheme();

  return (
    <div className="eduContainer">
      {eduArray.map((info, index) => (
        <EduCardStyled key={info} theme={themeName}>
          <div className="inputs">
            <InputHandler
              name="institution"
              id={`institution-${index}`}
              value={info.institution}
              type="education"
              label="Name of Institution"
              required
              onChange={(event) => handleEduExpChange(event, index)}
            />
            <InputHandler
              name="degree"
              id={`degree-${index}`}
              value={info.degree}
              type="education"
              label="Degree Obtained & Course"
              required
              onChange={(event) => handleEduExpChange(event, index)}
            />
            <InputHandler
              name="date"
              id={`date-${index}`}
              value={info.date}
              type="date"
              label="Graduation Date"
              required
              onChange={(event) => handleEduExpChange(event, index)}
            />
          </div>
          <ButtonActionStyled>
            <span className="del" onClick={() => handleDeleteEduInfo(index)}>
              <MdDelete />
            </span>
            <span className="add" onClick={() => handleAddEduInfo(index)}>
              <FaPlus />
            </span>
          </ButtonActionStyled>
        </EduCardStyled>
      ))}
    </div>
  );
};

export default EducationCard;